import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable, resetServerContext } from 'react-beautiful-dnd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Container, Input, Label, Row } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
resetServerContext()
//import { addcaseformAttributesets } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { addcaseformAttributegroup, getCaseFormAttributeGroups, getCaseFormsList, getcaseformAttributesets } from "../../../store/actions";
import { getCaseFormAttributeGroupDetail, updateCaseformAttributegroup } from "../../../store/admin/caseformattributesgroups/actions";
import {
  getFirstListStyle,
  getItemStyle,
  getListStyle,
  move,
  reorder
} from "../QnnrAttributeSets/helper";

const FormLayoutsBasic = () => {
  //SAVE DATA
  let form_id = '';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();



  const queryParams = new URLSearchParams(location.search);
  const editId = queryParams.get('id'); // Read the 'id' query parameter from the URL

  const { caseformattributesets } = useSelector((state) => ({
    caseformattributesets: state.caseformattributesets.caseformattributesets,
  }));

  const { CaseFormsList } = useSelector((state) => ({
    CaseFormsList: state.CaseFormsList.CaseFormsList,
  }));
  const { CaseFormsSelectList } = useSelector((state) => ({
    CaseFormsSelectList: state.CaseFormsList.CaseFormsSelectList,
  }));

  const { caseformattributegroups } = useSelector((state) => ({
    caseformattributegroups: state.caseformattributesgroups.caseformattributegroups,
  }));
  const { caseformattributeGroupDetail } = useSelector((state) => ({
    caseformattributeGroupDetail: state.caseformattributesgroups.caseformattributeGroupDetail,
  }));
  const [formData, setFormData] = useState({
    "title": "",
    "name": "",
    "shortDescription": "",
    "attributesSetsIds": "",
    "status": ""
  });
  useEffect(() => {
    if (editId) {
      dispatch(getCaseFormAttributeGroupDetail(editId));
    }
  }, [editId]);
  useEffect(() => {
    if (caseformattributeGroupDetail && Object.entries(caseformattributeGroupDetail).length > 0) {
      let { attributesSetsIds } = caseformattributeGroupDetail;
      let attributesArr = attributesSetsIds.split(',');
      let filteredList = caseformattributesets.filter((item) => {
        if (attributesArr.includes(item.id.toString())) {
          return item
        }
      })
      setFormData(caseformattributeGroupDetail);
      setLists({
        items: caseformattributesets,
        // selected: filteredList
        selected: caseformattributeGroupDetail.selectedAttributeSetsList
      });
    }
  }, [caseformattributeGroupDetail])
  // useEffect(() => {
  //   setFormData(caseformattributesets);
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getCaseFormsList());
  }, [dispatch]);



  useEffect(() => {
    if (formData?.form_id) {
      dispatch(getcaseformAttributesets({ form_id: formData?.form_id }));
    }
  }, [formData]);


  useEffect(() => {
    setLists(
      (prevState) => ({
        ...prevState,
        items: caseformattributesets
      }))
  }, [caseformattributesets]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const selectedOptionsUpdate = (options) => {
    var form_ids = options.map((opt) => opt.value).toString();
    setFormData({ ...formData, ["form_id"]: form_ids });
    setSelectedOptions(options.map((opt) => opt.value));
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onClickCancel = () => {
    navigate("/admin/case-form-attribute-groups");
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    let attributesSetsIds = lists.selected.map((item) => {
      return item.id;
    })

    attributesSetsIds = attributesSetsIds.join(",");
    let postBody = { ...formData, attributesSetsIds };
    if (postBody.title) {
      let response = {};
      if (Number(formData.id) > 0) {
        dispatch(updateCaseformAttributegroup(postBody));
      } else {
        dispatch(addcaseformAttributegroup(postBody));
      }
      setFormData({
        "form_id": "",
        "id": "",
        "title": "",
        "name": "",
        "shortDescription": "",
        "attributesSetsIds": "",
        "status": ""
      });
      dispatch(getCaseFormAttributeGroups());
      setTimeout(() => {
        navigate("/admin/case-form-attribute-groups");
      }, 3000);
    }
  }

  const [lists, setLists] = useState({ 'items': caseformattributesets, 'selected': [] });
  //console.log(lists, "======== available list items ========");
  const id2List = {
    droppable: 'items',
    droppable2: 'selected'
  };

  const getList = id => lists[id2List[id]];
  const onDragEnd = result => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { items };

      if (source.droppableId === 'droppable2') {
        state = { selected: items };
      }
      let newstate = {
        ...lists,
        ...state
      }
      setLists(newstate);

    } else {
      const result = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination
      );

      setLists({
        items: result.droppable,
        selected: result.droppable2
      });
    }
  };

  const BreadcrumbData = [
    { name: 'Case Form Attribute Groups', url: '/admin/case-form-attribute-groups' },
    { name: 'Add Case Form Attribute Group', url: '/admin/add-case-form-attribute-groups' }
  ]

  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex "
    };

    // prop assignment
    const props = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} /> &nbsp;
        {children}
      </components.Option>
    );
  };
  let title = editId ? 'Update Case Form Attribute Group' : 'Add Case Form Attribute Group';
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs breadcrumbItem={title} BreadcrumbData={BreadcrumbData} />

          <Row>
            <Col xs={12}>
              <form onSubmit={handleSubmit}>

                <div className="container">
                  <div className="row">
                    <DragDropContext onDragEnd={onDragEnd}>

                      <div className="col-lg-6 col-md-12">

                        <div className="card dashboard-secondbox dashboard-border-radius">
                          <h5>Case Form Attributes Set</h5>
                          <p>Please drag and drop and Make sets.</p>

                          <div className=''>
                            <div className="" style={{ 'height': '500px', 'overflowY': 'auto', 'overflowX': 'hidden' }}>
                              <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                  <ul className="list-group border"

                                    ref={provided.innerRef}
                                    style={getFirstListStyle(snapshot.isDraggingOver)}
                                  >
                                    {lists['items'].map((item, index) => (
                                      <Draggable
                                        key={item.id.toString()}
                                        draggableId={item.id.toString()}
                                        index={index}>
                                        {(provided, snapshot) => (
                                          <li className="list-group-item border"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          >
                                            {item.title}
                                          </li>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}

                                  </ul>
                                )}
                              </Droppable>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">
                        <div className="card dashboard-secondbox dashboard-border-radius">
                          <h5>Creat Case Form Attribute Group</h5>
                          <div className="">
                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInputTitle" className="form-label">
                                Title:
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="formGroupExampleInputTitle"
                                placeholder="Enter Title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                              />
                            </div>
                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput" className="form-label">
                                Name:
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="formGroupExampleInput"
                                placeholder="Enter Name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="mb-3">
                              <Label
                                htmlFor="horizontal-firstname-input"
                                className="col-sm-2 col-form-label"
                              >
                                Case Form:
                              </Label>
                              <div className="col-lg-6 col-md-12">
                                {/* <Input
                                  id="form_id"
                                  name="form_id"
                                  type="select"
                                  onChange={handleChange}
                                  disabled={caseformattributeGroupDetail?.form_id ? true : false}
                                >
                                  <option value="">Select Case Form</option>
                                  {CaseFormsList.map(row => (
                                    <option key={row.form_id} value={row.form_id} selected={row.form_id == caseformattributeGroupDetail?.form_id}>
                                      {row.form_name || row.name}
                                    </option>
                                  ))}
                                </Input> */}

                                <Select
                                  defaultValue={[]}
                                  value={CaseFormsSelectList.filter((value, index) => {
                                    if (formData?.form_id) {
                                      let selected = formData.form_id.split(",")
                                      return selected.includes(value.value)
                                    }
                                  })}
                                  isMulti
                                  // className={selectedOptions.length === 0 ? 'is-invalid':''}
                                  name="form_id"
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={true}
                                  selected={CaseFormsSelectList.filter(({ value }) =>
                                    caseformattributeGroupDetail?.form_id ?
                                      (caseformattributeGroupDetail.form_id.split(",")).includes(value) : ''
                                  )}
                                  // onChange={handleChange}
                                  onChange={(options) => {
                                    //console.log(options)
                                    if (Array.isArray(options)) {
                                      selectedOptionsUpdate(options)
                                    }
                                  }}

                                  // value={caseformattributeGroupDetail?.form_id ? caseformattributeGroupDetail.form_id : ''}
                                  options={CaseFormsSelectList}
                                  components={{
                                    Option: InputOption
                                  }}
                                />

                              </div><br></br>
                            </div>
                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput" className="form-label">
                                Case Form Attributes Set:
                              </label>
                              <p>Please drag and drop from left to right.</p>

                            </div>
                            <Droppable droppableId="droppable2">
                              {(provided, snapshot) => (
                                <ul className="list-group"
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}>
                                  {lists['selected'].map((item, index) => (
                                    <Draggable
                                      key={item.id.toString()}
                                      draggableId={item.id.toString()}
                                      index={index}>
                                      {(provided, snapshot) => (
                                        <li className="list-group-item"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}>
                                          {item.title}
                                        </li>
                                      )}
                                    </Draggable>
                                  ))}
                                  {provided.placeholder}
                                </ul>
                              )}
                            </Droppable>



                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput" className="form-label">
                                Short Description
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="formGroupExampleInput"
                                name="shortDescription"
                                placeholder="Enter Short Description"
                                value={formData.shortDescription}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput2" className="form-label">
                                Status:
                              </label>


                              <Input
                                id="validationCustom02"
                                name="status"
                                type="select"
                                onChange={handleChange}
                                value={formData.status || ""}

                              >
                                <option >Open this select status</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                              </Input>




                            </div>
                            <button type="button" className="btn btn-secondary" onClick={onClickCancel}>
                              Cancel
                            </button> {' '}
                            <button type="submit" className="btn btn-primary">
                              save
                            </button>

                          </div>

                        </div>

                      </div>

                    </DragDropContext>
                  </div>
                </div>

              </form>
            </Col>
          </Row>


        </Container>
      </div>
    </React.Fragment>
  );
};
export default FormLayoutsBasic
